import React from 'react';
import { observer } from 'mobx-react';
import { NumberStore } from 'ui/base/input/store';
import { InputProps } from 'ui/base/types';

export type NumberInputProps = Omit<InputProps, 'type' | 'value' | 'onChange'> & {
  store: NumberStore;
  step: number;
  min?: number;
  max?: number;
};

export const NumberInput = observer(({ store, step, min, max, className, ...props }: NumberInputProps) => {
  const inputRef = React.useRef<HTMLInputElement>(null);

  const commitChange = React.useCallback(() => {
    const target = inputRef?.current;
    if (target) {
      const number = !target.value ? NaN : +target.value;
      const string = isNaN(number) ? '' : number.toString();

      store.setValue(number);
      target.value = string;
    }
  }, [inputRef, store]);

  const onStepUp = React.useCallback(() => {
    inputRef?.current?.stepUp(); commitChange();
  }, [inputRef, commitChange]);

  const onStepDown = React.useCallback(() => {
    inputRef?.current?.stepDown(); commitChange();
  }, [inputRef, commitChange]);

  const val = store.value;

  const inputMin = min != null && !isNaN(min) ? min : undefined;
  const inputMax = max != null && !isNaN(max) ? max : undefined;
  const inputVal = val != null && !isNaN(val) ? val : undefined;

  return (
    <div className={className}>
      <button
        type='button'
        onClick={onStepDown}
      />
      <input
        type='number'
        ref={inputRef} step={step}
        min={inputMin} max={inputMax}
        defaultValue={inputVal}
        onChange={commitChange}
        onBlur={commitChange}
        {...props}
      />
      <button
        type='button'
        onClick={onStepUp}
      />
    </div>
  );
});
